module.exports = __webpack_public_path__ + "static/parade-2019-house16-51cdf37ab2ce349323afed506a8df6c4.jpg";